import { render, staticRenderFns } from "./UpdatePriceModal.vue?vue&type=template&id=386a866d"
import script from "./UpdatePriceModal.vue?vue&type=script&lang=js"
export * from "./UpdatePriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports